__turbopack_context__.v({
  "errorStateInvalidPassword": "PasswordForm-module-scss-module__JY80ra__errorStateInvalidPassword",
  "invalid": "PasswordForm-module-scss-module__JY80ra__invalid",
  "passwordContainer": "PasswordForm-module-scss-module__JY80ra__passwordContainer",
  "passwordErrorIconContainer": "PasswordForm-module-scss-module__JY80ra__passwordErrorIconContainer",
  "passwordInput": "PasswordForm-module-scss-module__JY80ra__passwordInput",
  "passwordInputContainer": "PasswordForm-module-scss-module__JY80ra__passwordInputContainer",
  "passwordSubmit": "PasswordForm-module-scss-module__JY80ra__passwordSubmit",
});
